import { NavLink } from 'react-router-dom';
import { navFor, NavContext } from './navConfig';

/**
 * Fixed mobile bottom navigation (PRD §6.4): 68px + safe-area inset, 44px
 * touch targets. Carries the primary tabs only — Dashboard + Application in
 * release 1 — everything else lives in the hamburger drawer. Membership is
 * decided by navConfig (the 'bottom' surface, capped at 4 as a safety rail).
 */
export default function BottomNav({ navCtx }: { navCtx: NavContext }) {
  const items = navFor('bottom', navCtx);
  return (
    <nav className="bottomnav" aria-label="Primary" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
      {items.map(({ key, label, to, Icon }) => (
        <NavLink key={key} to={to} className={({ isActive }) => (isActive ? 'active' : '')}>
          <Icon size={22} aria-hidden />
          {label.replace(/^My /, '')}
        </NavLink>
      ))}
    </nav>
  );
}
